import { getDefaultCampaignTitle } from '../../organization-model';
import { useOrganization } from '../../useOrganization';
import { useEffect, useRef, useState } from 'react';
import RoundedButtonSecondary from '../../../components/button/rounded-button-secondary/RoundedButtonSecondary';
import styles from './organization-cta-templates.module.less';
import { Input, Label } from '@sb1/ffe-form-react';
import { SECONDARY_ORGANIZATION_COLOR } from '../../theme/OrganizationTheme';
import ButtonText from '../../../components/button/button-text/ButtonText';
import RoundedButtonPrimary from '../../../components/button/rounded-button-primary/RoundedButtonPrimary';
import { updateOrganizationInfo } from '../../organization-actions';
import { useDispatch } from 'react-redux';
import { Heading2 } from '@sb1/ffe-core-react';

export const OrganizationCauseTitle = ({ editable }) => {
    const organization = useOrganization();
    const textfield = useRef(null);
    const dispatch = useDispatch();
    const [title, setTitle] = useState();
    const [editing, setEditing] = useState(false);

    const campaignTitle = organization?.campaignTitle;
    const defaultCampaignTitle = getDefaultCampaignTitle({ organization });

    useEffect(() => {
        if (campaignTitle) {
            setTitle(campaignTitle);
        } else {
            setTitle(defaultCampaignTitle);
        }
    }, [editable, campaignTitle, defaultCampaignTitle]);

    useEffect(() => {
        if (textfield.current && editing) {
            textfield.current.focus();
        }
    }, [textfield.current, editing]);
    const doEditing = () => {
        setEditing(true);
    };

    const updateOrganizationCauseTitle = () => {
        dispatch(updateOrganizationInfo({ id: organization.id, profile: { campaignTitle: title || null } }));
        setEditing(false);
    };

    if (!editable) {
        return (
            <Heading2 lookLike={3} className={styles.organizationCauseTitle}>
                {title}
            </Heading2>
        );
    }
    if (!editing) {
        return (
            <div>
                <Heading2 lookLike={3} className={styles.organizationCauseTitle}>
                    {title}
                </Heading2>
                <RoundedButtonSecondary onClick={doEditing}>
                    <i className={'fa-regular fa-pen-to-square'} /> Rediger tittel
                </RoundedButtonSecondary>
            </div>
        );
    }
    return (
        <div className={styles.organizationCauseTitle}>
            <Label className={styles.label} htmlFor={'input-cause-title'}>
                Lag en tittel for aksjonene deres
            </Label>
            <Input
                ref={textfield}
                onChange={(evt) => {
                    setTitle(evt.target.value);
                }}
                value={title}
                id={'input-cause-title'}
                className={[styles.causeTitleInput, SECONDARY_ORGANIZATION_COLOR].join(' ')}
                maxLength={255}
                defaultValue={getDefaultCampaignTitle({ organization })}
            />
            <div className={styles.editButtons}>
                <ButtonText onClick={() => setEditing(false)}>Avbryt</ButtonText>
                <RoundedButtonPrimary onClick={updateOrganizationCauseTitle}>Lagre</RoundedButtonPrimary>
            </div>
        </div>
    );
};
